module.exports = __webpack_public_path__ + "img/cases.0a737be6.svg";